export const tours = [
  {
    id: 1,
    key: 'city',
    title: "City Highlights Tour",
    duration: "4 hours",
    price: "£45",
    perPerson: true,
    hasMinimumBooking: false,
    minimumPeople: null,
    description: "Explore the best attractions and landmarks in the city with our expert guide.",
    features: ["Professional guide", "Comfortable seating", "Photo stops"]
  },
  {
    id: 2,
    key: 'wine',
    title: "Wine Country Adventure",
    duration: "8 hours",
    price: "£125",
    hasMinimumBooking: true,
    minimumPeople: 4,
    description: "Visit premier wineries and enjoy scenic countryside views.",
    features: ["Wine tastings", "Gourmet lunch", "Scenic routes"]
  },
  {
    id: 3,
    key: 'historical',
    title: "Historical Heritage Tour",
    duration: "6 hours",
    price: "£85",
    hasMinimumBooking: true,
    minimumPeople: 6,
    description: "Journey through historical sites and learn about local heritage.",
    features: ["Museum visits", "Historical sites", "Expert commentary"]
  },
  {
    id: 4,
    key: 'custom',
    title: "Custom Tour",
    duration: "Variable",
    price: "Contact us",
    hasMinimumBooking: false,
    minimumPeople: null,
    description: "Create your own personalized tour experience.",
    features: ["Customizable itinerary", "Flexible duration", "Personal guide"]
  }
];

export const getTourByKey = (key) => {
  return tours.find(tour => tour.key === key);
};

export const getTourMapping = () => {
  const mapping = {};
  tours.forEach(tour => {
    mapping[tour.title] = tour.key;
  });
  return mapping;
};